import { ClbFullPageFlow } from "@celebration/design-system-react";

export const ClbFullPageFlowAdapter = (
  props: React.ComponentProps<typeof ClbFullPageFlow>
) => <ClbFullPageFlow
    {...props}
  />